let value = ("undefined" !== typeof self ? self : this)["webpackJsonpvuecal"] || [];
(value).push([[5], {
    "442f": function (e) {
        e.exports = JSON.parse(`{
            "weekDays": ["Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota", "Neděle"],
            "months": ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
            "years": "Roky",
            "year": "Rok",
            "month": "Měsíc",
            "week": "Týden",
            "day": "Den",
            "today": "Dnes",
            "noEvent": "Bez událostí",
            "allDay": "Celý den",
            "deleteEvent": "Odstranit",
            "createEvent": "Vytvořit událost",
            "dateFormat": "dddd D. MMMM YYYY"
        }`)
    }
}]);